import { CircleCheck, TriangleAlert } from "lucide-react";

import { Badge } from "@/components/ui/badge";

const CapiTestEventResult = ({ result }) => {
  // Meta's reply, separated from the request echo the endpoint wraps around it.
  const metaReply = result.ok
    ? result.body?.response
    : result.body?.request
      ? { error: result.body.error, message: result.body.message }
      : result.body;

  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <Badge
        variant={result.ok ? "secondary" : "destructive"}
        className="tw:w-fit"
      >
        {result.ok ? (
          <CircleCheck className="tw:max-h-4 tw:text-[var(--color-teal)]" />
        ) : (
          <TriangleAlert className="tw:max-h-4" />
        )}
        {result.ok ? "Meta accepted the event" : "Meta rejected the event"}
      </Badge>
      {result.body?.request && (
        <>
          <span className="tw:text-sm tw:font-medium tw:text-[var(--color-text-secondary)]">
            Request sent
          </span>
          <pre className="tw:overflow-x-auto tw:rounded-md tw:border tw:border-[var(--color-border)] tw:bg-[var(--color-surface)] tw:p-3 tw:text-sm tw:text-[var(--color-text-primary)]">
            {JSON.stringify(result.body.request, null, 2)}
          </pre>
        </>
      )}
      <span className="tw:text-sm tw:font-medium tw:text-[var(--color-text-secondary)]">
        Meta response
      </span>
      <pre className="tw:overflow-x-auto tw:rounded-md tw:border tw:border-[var(--color-border)] tw:bg-[var(--color-surface)] tw:p-3 tw:text-sm tw:text-[var(--color-text-primary)]">
        {JSON.stringify(metaReply, null, 2)}
      </pre>
    </div>
  );
};

export default CapiTestEventResult;
